import { AuthService } from '../services/auth.service';

export const displayUsername = (
    username: string | null | undefined,
    institutionCode?: string | null,
): string => {
    if (!username) return '';
    const code = institutionCode ?? AuthService.getSelectedInstitutionCode();
    if (code) {
        const prefix = `${code}_`;
        if (username.startsWith(prefix)) {
            return username.slice(prefix.length);
        }
    }
    return username;
};
